import { NgModule } from '@angular/core';

import { TimeFromNowPipe } from './time-from-now.pipe';

@NgModule({
  exports: [TimeFromNowPipe],
  declarations: [TimeFromNowPipe],
})
export class TimeFromNowPipeModule {}
